export default __webpack_public_path__ + "static/media/2P_GW152.a31b55e7.png";